import { useOutletContext } from "react-router-dom";
import type { ProjectOutletContext } from "~/pages/manifold-nextgen/components/projects/ProjectLayout";

export interface PinTarget {
  // The canonical UUID, not the route's short_id. Every pin call keys its SWR
  // cache on this, and a pin's own `project_id` is a UUID — mixing the two
  // forms would leave a card subscribed to one key while a refresh revalidates
  // another.
  projectId: string;
}

/** The project an artifact could be pinned to from here, or null.
 *
 * Returns null outside a project route — the admin and shared-conversation
 * views render the same artifact cards but sit outside the project outlet, so
 * `useOutletContext` has nothing to give them. Also null for a member who
 * cannot curate: pinning is manager-gated, and the backend would refuse.
 */
export const usePinTarget = (): PinTarget | null => {
  const context = useOutletContext<ProjectOutletContext | null>();
  if (!context?.project?.id || !context.isOwner) return null;
  return { projectId: context.project.id };
};
